import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;

// push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

export default new Router({
    routes: [
        {
            path: '/',
            component: resovle => require([/* webpackChunkName: "main" *//* webpackChunkName: "main" */ '../views/main/Main.vue'],resovle),
            meta: { title: '主页' },
            children: [        
                {
                    path: '/SystemMain',
                    component: resovle => require([/* webpackChunkName: "main" *//* webpackChunkName: "main" */ '../views/beadhouse/SystemMain.vue'],resovle),
                    meta: { title: '院务管理' }
                },
                {
                    path: '/Department',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/beadhouse/department/Department.vue'],resovle),
                    meta: { title: '部门管理' }
                }, 
                {
                    path: '/NursingManagement',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/beadhouse/nursing/NursingManagement.vue'],resovle),
                    meta: { title: '员工管理' }
                },
                {
                    path: '/KaoqinView',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/beadhouse/attendance/KaoqinView.vue'],resovle),
                    meta: { title: '考勤管理' }
                },
                {
                    path: '/RoomBedManager',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/beadhouse/build/RoomBedManager.vue'],resovle),
                    meta: { title: '楼栋房间管理' }
                },{
                    path: '/WorkLogManage',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/beadhouse/worklog/WorkLogManage.vue'],resovle),
                    meta: { title: '工作安全管理' }
                },
                {
                    path: '/WorkLog',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/beadhouse/worklog/WorkLog.vue'],resovle),
                    meta: { title: '工作日志' }
                },
                {
                    path: '/WorkLogList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/beadhouse/worklog/WorkLogList.vue'],resovle),
                    meta: { title: '工作日志管理' }
                },
                {
                    path: '/SafeLog',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/beadhouse/worklog/SafeLog.vue'],resovle),
                    meta: { title: '安全检查日志' }
                },
                {
                    path: '/SafeLogList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/beadhouse/worklog/SafeLogList.vue'],resovle),
                    meta: { title: '安全检查日志管理' }
                },
                {
                    path: '/VideoView',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/beadhouse/video/VideoView.vue'],resovle),
                    meta: { title: '院内监控看板' }
                },
                {
                    path: '/BuildView',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/beadhouse/build/BuildView.vue'],resovle),
                    meta: { title: '楼栋管理' }
                },
                {
                    path: '/RoomSetting',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/beadhouse/build/RoomSetting.vue'],resovle),
                    meta: { title: '房间管理' }
                },
                {
                    path: '/BedSetting',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/beadhouse/build/BedSetting.vue'],resovle),
                    meta: { title: '床位管理' }
                },
                {
                    path: '/BedSetting',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/beadhouse/build/BedSetting.vue'],resovle),
                    meta: { title: '床位管理' }
                },
                {
                    path: '/RoomView',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/beadhouse/build/RoomView.vue'],resovle),
                    meta: { title: '床位视图' }
                },
                {
                    path: '/BedRearrangement',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/beadhouse/build/BedRearrangement.vue'],resovle),
                    meta: { title: '床位号重排' }
                },
                {
                    path: '/BedOldSetting',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/beadhouse/build/BedOldSetting.vue'],resovle),
                    meta: { title: '床位入住' }
                },
                /**长者管理 */
                {
                    path: '/ResidentManager',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/ResidentManager.vue'],resovle),
                    meta: { title: '长者管理' }
                },
                {
                    path: '/ElderList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/ElderList.vue'],resovle),
                    meta: { title: '长者管理' }
                },
                {
                    path: '/flyOldmanList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/fly/flyOldmanList.vue'],resovle),
                    meta: { title: '院内老人管理' }
                },
                {
                    path: '/flyOldmanAdd',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/fly/flyOldmanAdd.vue'],resovle),
                    meta: { title: '新增老人' }
                },
                {
                    path: '/flyOldmanEdit',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/fly/flyOldmanEdit.vue'],resovle),
                    meta: { title: '编辑老人' }
                },
                {
                    path: '/flyOldmanDetail',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/fly/flyOldmanDetail.vue'],resovle),
                    meta: { title: '长者详情' }
                },
                {
                    path: '/ResidentAdd',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/ResidentAdd.vue'],resovle),
                    meta: { title: '长者新增' }
                },   
                {
                    path: '/ResidentManagerWr',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/wr/ResidentManager.vue'],resovle),
                    meta: { title: '长者管理' }
                },
                {
                    path: '/citizenList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/citizenList.vue'],resovle),
                    meta: { title: '长者管理' }
                },
                {
                    path: '/ResidentAddWr',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/wr/ResidentAdd.vue'],resovle),
                    meta: { title: '长者新增' }
                },   
                {
                    path: '/Oldmanmap',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/Oldmanmap.vue'],resovle),
                    meta: { title: '长者地图' }
                },
                {
                    path: '/ResidentDetail',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/ResidentDetail.vue'],resovle),
                    meta: { title: '长者档案' }
                },
                {
                    path: '/AdmissionManager',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/AdmissionManager.vue'],resovle),
                    meta: { title: '入院管理' }
                },
                {
                    path: '/AdmissionConsult',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/admission/AdmissionConsult.vue'],resovle),
                    meta: { title: '预约咨询' }
                },
                {
                    path: '/AdmissionPg',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/admission/AdmissionPg.vue'],resovle),
                    meta: { title: '入院评估' }
                },
                {
                    path: '/AdmissionCancel',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/admission/AdmissionCancel.vue'],resovle),
                    meta: { title: '取消预约' }
                },
                {
                    path: '/AdmissionOlderList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/admission/AdmissionOlderList.vue'],resovle),
                    meta: { title: '入院办理' }
                },
                {
                    path: '/OlderDetailAdd',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/admission/AdmissionOlderDetailAdd.vue'],resovle),
                    meta: { title: '新增入院' },
                    children: [
                        {
                            path: '/OlderDetailAddBase',
                            component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/admission/OlderDetailAddBase.vue'],resovle),
                            meta: { title: '基本信息录入' }
                        },
                        {
                            path: '/OlderDetailFeeChoose',
                            component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/admission/OlderDetailFeeChoose.vue'],resovle),
                            meta: { title: '收费项目选择' }
                        },
                        {
                            path: '/OlderDetailFeeEnter',
                            component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/admission/OlderDetailFeeEnter.vue'],resovle),
                            meta: { title: '缴费信息录入' }
                        }
                    ]
                },
                {
                    path: '/ContractManage',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/contract/ContractManage.vue'],resovle),
                    meta: { title: '合同管理' }
                },
                {
                    path: '/ContractAdd',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/contract/ContractAdd.vue'],resovle),
                    meta: { title: '合同信息' }
                },
                {
                    path: '/LeaveManagement',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/leave/LeaveManagement.vue'],resovle),
                    meta: { title: '出院管理' }
                },
                {
                    path: '/LeaveHistoryList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/leave/LeaveHistoryList.vue'],resovle),
                    meta: { title: '出院记录' }
                },
                {
                    path: '/LeaveHospital',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/leave/LeaveHospital.vue'],resovle),
                    meta: { title: '出院申请' }
                },
                {
                    path: '/LeaveHospitalApproval',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/leave/LeaveHospitalApproval.vue'],resovle),
                    meta: { title: '出院审批' }
                },
                {
                    path: '/LeaveHospitalDetail',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/leave/LeaveHospitalDetail.vue'],resovle),
                    meta: { title: '出院详情' }
                },
                {
                    path: '/ResidentLeave',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/leave/ResidentLeave.vue'],resovle),
                    meta: { title: '长者迁出' }
                },
                {
                    path: '/LeaveRecordList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/elder/leave/LeaveRecordList.vue'],resovle),
                    meta: { title: '迁出记录' }
                },
                {
                    path: '/jChart',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/jn/SiteChart.vue'],resovle),
                    meta: { title: '系统首页' }
                },
                {
                    path: '/StreetChart',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/jn/StreetChart.vue'],resovle),
                    meta: { title: '系统首页' }
                },
                {
                    path: '/sceneList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/intellectdevice/scene/sceneList.vue'],resovle),
                    meta: { title: '场景详情' }
                },
                {
                    path: '/canteenMain',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/canteen/canteenMain.vue'],resovle),
                    meta: { title: '食堂看板' }
                },
                {
                    path: '/ZhaoPinText',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/site/ZhaoPinText.vue'],resovle),
                    meta: { title: '招聘申请' }
                },
                {
                    path: '/huzhuNeed',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/site/huzhuNeed.vue'],resovle),
                    meta: { title: '互助养老服务' }
                },
                {
                    path: '/AdmissionConsultText',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/site/AdmissionConsultText.vue'],resovle),
                    meta: { title: '居民咨询' }
                },
                {
                    path: '/SiteChart',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/site/SiteChart.vue'],resovle),
                    meta: { title: '系统首页' }
                },
                {
                    path: '/SiteManagement',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/site/SiteManagement.vue'],resovle),
                    meta: { title: '站点管理' }
                },
                {
                    path: '/SiteInfo',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/site/SiteInfo.vue'],resovle),
                    meta: { title: '站点介绍' }
                },
                {
                    path: '/groupDbData',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/setting/groupDbData.vue'],resovle),
                    meta: { title: '数据上报' }
                },
                {
                    path: '/ConvenientSearchPj',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/site/ConvenientSearchPj.vue'],resovle),
                    meta: { title: '便民查询项目' }
                },
                {
                    path: '/ConvenientSearchRecord',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/site/ConvenientSearchRecord.vue'],resovle),
                    meta: { title: '便民查询记录' }
                },
                {
                    path: '/MultiRoomList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/site/MultiRoomList.vue'],resovle),
                    meta: { title: '多功能活动室' }
                },
                {
                    path: '/SwipeCardRecord',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/site/SwipeCardRecord.vue'],resovle),
                    meta: { title: '客流量统计' }
                },
                {
                    path: '/BaseInfo',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/site/BaseInfo.vue'],resovle),
                    meta: { title: '基础信息' }
                },
                //财务
                {
                    path: '/ChargeManagement',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/finance/ChargeManagement.vue'],resovle),
                    meta: { title: '财务管理' }
                },
                {
                    path: '/financeView',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/finance/financeView.vue'],resovle),
                    meta: { title: '财务报表' }
                },
                {
                    path: '/ChargeCategoryManagement',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/finance/ChargeCategoryManagement.vue'],resovle),
                    meta: { title: '费用类别管理' }
                },
                {
                    path: '/PaymentRecord',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/finance/PaymentRecord.vue'],resovle),
                    meta: { title: '费用记录单' }
                },
                {
                    path: '/MonthReceivableList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/finance/MonthReceivableList.vue'],resovle),
                    meta: { title: '月度应收账款' }
                },
                {
                    path: '/ConsumptionRecord',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/finance/ConsumptionRecord.vue'],resovle),
                    meta: { title: '消费记录' }
                },
                {
                    path: '/FeeBindList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/finance/FeeBindList.vue'],resovle),
                    meta: { title: '费用绑定清单' }
                },
                {
                    path: '/RechargeRecord',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/finance/RechargeRecord.vue'],resovle),
                    meta: { title: '缴费审批记录' }
                },
                {
                    path: '/ArrearageList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/finance/ArrearageList.vue'],resovle),
                    meta: { title: '余额管理' }
                },
                {
                    path: '/admissionExpensesDetail',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/finance/admissionExpensesDetail.vue'],resovle),
                    meta: { title: '费用清单详情' }
                },
                {
                    path: '/PersonCategoryManagement',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/finance/PersonCategoryManagement.vue'],resovle),
                    meta: { title: '老人类别管理' }
                },
                {
                    path: '/personCategoryReduction',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/finance/personCategoryReduction.vue'],resovle),
                    meta: { title: '老人类别减免' }
                },
                {
                    path: '/MonthFinanceView',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/finance/MonthFinanceView.vue'],resovle),
                    meta: { title: '月度费用汇总' }
                },
                {
                    path: '/ServiceFeeManagement',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/finance/ServiceFeeManagement.vue'],resovle),
                    meta: { title: '费用统计' }
                },
                {
                    path: '/PackageManagement',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/finance/PackageManagement.vue'],resovle),
                    meta: { title: '套餐管理' }
                },
                // 护理
                {
                    path: '/OldVisitTable',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/dongxihu/OldVisitTable.vue'],resovle),
                    meta: { title: '入院参观信息' }
                },
                {
                    path: '/OldVisitAdd',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/dongxihu/OldVisitAdd.vue'],resovle),
                    meta: { title: '新增入院参观' }
                },
                {
                    path: '/OldReservationTable',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/dongxihu/OldReservationTable.vue'],resovle),
                    meta: { title: '预约登记表' }
                },
                {
                    path: '/OldReservationAdd',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/dongxihu/OldReservationAdd.vue'],resovle),
                    meta: { title: '新增预约登记' }
                },
                {
                    path: '/FoodRetention',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/dongxihu/FoodRetention.vue'],resovle),
                    meta: { title: '食品留样记录表' }
                },
                {
                    path: '/EldOutTable',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/dongxihu/EldOutTable.vue'],resovle),
                    meta: { title: '院民出入登记表' }
                },
                {
                    path: '/careManage',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/careManage.vue'],resovle),
                    meta: { title: '护理管理' }
                },
                {
                    path: '/SchedulingManage',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/scheduling/SchedulingManage.vue'],resovle),
                    meta: { title: '排班管理' }
                },
                {
                    path: '/NursingArrangePlan',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/scheduling/NursingArrangePlan.vue'],resovle),
                    meta: { title: '护工排班方案' }
                },
                {
                    path: '/ThisWeekArrangePlan',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/scheduling/ThisWeekArrangePlan.vue'],resovle),
                    meta: { title: '本周排班计划' }
                },
                {
                    path: '/SchedulingPlanApproval',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/scheduling/SchedulingPlanApproval.vue'],resovle),
                    meta: { title: '排班计划审批' }
                },
                {
                    path: '/MonthArrangeScheme',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/scheduling/MonthArrangeScheme.vue'],resovle),
                    meta: { title: '月排班方案' }
                },
                {
                    path: '/ThisMonthArrangePlan',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/scheduling/ThisMonthArrangePlan.vue'],resovle),
                    meta: { title: '本月排班计划' }
                },
                {
                    path: '/SchedulingMonthApproval',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/scheduling/SchedulingMonthApproval.vue'],resovle),
                    meta: { title: '月排班计划审批' }
                },
                {
                    path: '/LifeServiceManagement',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/nurse/LifeServiceManagement.vue'],resovle),
                    meta: { title: '护理记录' }
                },
                {
                    path: '/NursingHandoverLog',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/nurse/NursingHandoverLog.vue'],resovle),
                    meta: { title: '交班日志' }
                },
                {
                    path: '/HandoverLogLook',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/nurse/HandoverLogLook.vue'],resovle),
                    meta: { title: '交班日志管理' }
                },
                {
                    path: '/NursingLog',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/nurse/NursingLog.vue'],resovle),
                    meta: { title: '护工护理日志' }
                },
                {
                    path: '/NursingLogManagement',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/nurse/NursingLogManagement.vue'],resovle),
                    meta: { title: '护理日志管理' }
                },
                {
                    path: '/MonitorLog',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/nurse/MonitorLog.vue'],resovle),
                    meta: { title: '班长日志' }
                },
                {
                    path: '/MonitorLogManagement',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/nurse/MonitorLogManagement.vue'],resovle),
                    meta: { title: '班长日志管理' }
                },
                {
                    path: '/PatrolLog',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/nurse/PatrolLog.vue'],resovle),
                    meta: { title: '巡查日志' }
                },
                {
                    path: '/DutyLogList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/nurse/DutyLogList.vue'],resovle),
                    meta: { title: '值班日志' }
                },
                {
                    path: '/TableCareProject',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/nurse/TableCareProject.vue'],resovle),
                    meta: { title: '长者护理记录' }
                },
                {
                    path: '/TableCareList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/nurse/TableCareList.vue'],resovle),
                    meta: { title: '日常护理记录' }
                },
                {
                    path: '/TableSpecialCareList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/nurse/TableSpecialCareList.vue'],resovle),
                    meta: { title: '特殊护理记录' }
                },
                {
                    path: '/MedicalCare',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/examine/MedicalCare.vue'],resovle),
                    meta: { title: '体检记录' }
                },
                {
                    path: '/ExaminationDetailAdd',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/examine/ExaminationDetailAdd.vue'],resovle),
                    meta: { title: '体检详情' }
                },
                {
                    path: '/OldmanBirthday',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/OldmanBirthday.vue'],resovle),
                    meta: { title: '老人生日' }
                },
                {
                    path: '/OldmanLeave',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/OldmanLeave.vue'],resovle),
                    meta: { title: '老人请假' }

                },
                {
                    path: '/changeBedManage',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/change/changeBedManage.vue'],resovle),
                    meta: { title: '调房调级' }
                },
                {
                    path: '/ReviseRecordList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/change/ReviseRecordList.vue'],resovle),
                    meta: { title: '调房调级记录' }
                },
                {
                    path: '/ReviseAdd',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/change/ReviseAdd.vue'],resovle),
                    meta: { title: '调房调级申请' }
                },
                {
                    path: '/changeFeeList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/change/changeFeeList.vue'],resovle),
                    meta: { title: '调房调级申请' }
                },
                {
                    path: '/changeFeeRootList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/change/changeFeeRootList.vue'],resovle),
                    meta: { title: '调房调级审批' }
                },
                {
                    path: '/changeFeeAdd',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/change/changeFeeAdd.vue'],resovle),
                    meta: { title: '调房调级新增' }
                },
                {
                    path: '/changeFeeShow',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/change/changeFeeShow.vue'],resovle),
                    meta: { title: '调房调级查看' }
                },
                {
                    path: '/MedicalManage',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/drug/MedicalManage.vue'],resovle),
                    meta: { title: '用药管理' }
                },
                {
                    path: '/PharmacyHistoryRecord',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/drug/PharmacyHistoryRecord.vue'],resovle),
                    meta: { title: '历史用药记录' }
                },
                {
                    path: '/MedicalPlanList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/drug/MedicalPlanList.vue'],resovle),
                    meta: { title: '用药计划' }
                },
                {
                    path: '/PharmacyRecord',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/drug/PharmacyRecord.vue'],resovle),
                    meta: { title: '用药记录' }
                },
                {
                    path: '/callSolicitudelPlan',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/solicitude/callPlan.vue'],resovle),
                    meta: { title: '去电关怀计划' }
                },
                {
                    path: '/callSolicitudelList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/solicitude/callList.vue'],resovle),
                    meta: { title: '去电关怀任务' }
                },
                {
                    path: '/callSolicitudelHistory',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/solicitude/callHistory.vue'],resovle),
                    meta: { title: '去电关怀记录' }
                },{
                    path: '/interviewPlan',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/solicitude/interviewPlan.vue'],resovle),
                    meta: { title: '走访关怀计划' }
                },
                {
                    path: '/interviewList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/solicitude/interviewList.vue'],resovle),
                    meta: { title: '走访关怀任务' }
                },
                {
                    path: '/interviewHistory',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/solicitude/interviewHistory.vue'],resovle),
                    meta: { title: '走访关怀记录' }
                },
                {
                    path: '/canyinManagement',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/food/canyinManagement.vue'],resovle),
                    meta: { title: '餐饮管理' }
                },
                {
                    path: '/FoodManagement',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/food/FoodManagement.vue'],resovle),
                    meta: { title: '食物管理' }
                },
                {
                    path: '/WeeklyMenu',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/food/WeeklyMenu.vue'],resovle),
                    meta: { title: '每周菜谱' }
                },
                {
                    path: '/WuziManage',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/storage/WuziManage.vue'],resovle),
                    meta: { title: '物资管理' }
                },
                {
                    path: '/StorageCatalogManage',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/storage/StorageCatalogManage.vue'],resovle),
                    meta: { title: '物资项目管理' }
                },
                {
                    path: '/StorageStockManage',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/storage/StorageStockManage.vue'],resovle),
                    meta: { title: '物资库存表' }
                },
                {
                    path: '/StorageInTable',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/storage/StorageInTable.vue'],resovle),
                    meta: { title: '物资入库表' }
                },
                {
                    path: '/StorageOutTable',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/storage/StorageOutTable.vue'],resovle),
                    meta: { title: ' 物资出库表' }
                },

                {
                    path: '/FoodCatalogManage',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/food/FoodCatalogManage.vue'],resovle),
                    meta: { title: '物资管理' }
                },
                {
                    path: '/FoodStockManage',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/food/FoodStockManage.vue'],resovle),
                    meta: { title: '库存盘点' }
                },
                {
                    path: '/FoodInTable',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/food/FoodInTable.vue'],resovle),
                    meta: { title: '食材入库表' }
                },
                {
                    path: '/FoodOutTable',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/care/food/FoodOutTable.vue'],resovle),
                    meta: { title: ' 食材出库表' }
                },
                {
                    path: '/WuZiResign',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/storage/WuZiResign.vue'],resovle),
                    meta: { title: ' 物资消杀登记' }
                },
                {
                    path: '/healthDeviceHome',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/healthDeviceHome.vue'],resovle),
                    meta: { title: '健康监测管理' }
                },
                {
                    path: '/qlRadarList',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/qlradar/QLRadarlist.vue'],resovle),
                    meta: { title: '生命体征监测仪' }
                },
                {
                    path: '/qlRadarDetail',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/qlradar/QLRadarDetail.vue'],resovle),
                    meta: { title: '生命体征详情' }
                },
                {
                    path: '/qlFallRadarList',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/qlradar/QLFallRadarlist.vue'],resovle),
                    meta: { title: '毫米波跌倒检测仪' }
                },
                {
                    path: '/qlFallRadarDetail',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/qlradar/QLFallRadarDetail.vue'],resovle),
                    meta: { title: '跌倒检测仪详情' }
                },
                {
                    path: '/healthRadarList',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/radar/Radarlist.vue'],resovle),
                    meta: { title: '体征监测雷达' }
                },
                {
                    path: '/RadarDeviceKanBan',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/radar/RadarDeviceKanBan.vue'],resovle),
                    meta: { title: '体征雷达看板' }
                },
                {
                    path: '/FallRadarKanBan',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/fall/FallRadarKanBan.vue'],resovle),
                    meta: { title: '跌倒雷达看板' }
                },
                {
                    path: '/BedRadarManagement',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/radar/BedRadarManagement.vue'],resovle),
                    meta: { title: '床位看板' }
                },
                {
                    path: '/RadarDetail',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/radar/RadarDetail.vue'],resovle),
                    meta: { title: '雷达详情' }
                },
                {
                    path: '/SleepMattresslist',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/mattress/SleepMattresslist.vue'],resovle),
                    meta: { title: '睡眠监测带' }
                },
                {
                    path: '/SleepMattressLive',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/mattress/SleepMattressLive.vue'],resovle),
                    meta: { title: '睡眠详情' }
                },
                {
                    path: '/SleepMattressDetail',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/mattress/SleepMattressDetail.vue'],resovle),
                    meta: { title: '睡眠报告' }
                },
                {
                    path: '/Followlist',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/follow/Followlist.vue'],resovle),
                    meta: { title: '多功能检测仪' }
                },
                {
                    path: '/Followtestdetail',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/follow/Followtestdetail.vue'],resovle),
                    meta: { title: '测量数据' }
                },
                {
                    path: '/BloodPressList',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/bloodpress/BloodPressList.vue'],resovle),
                    meta: { title: '4G血压计' }
                },
                {
                    path: '/BloodPressData',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/bloodpress/BloodPressData.vue'],resovle),
                    meta: { title: '血压计详情' }
                },
                {
                    path: '/BloodSugarList',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/bloodsugar/BloodSugarList.vue'],resovle),
                    meta: { title: '4G血糖仪' }
                },
                {
                    path: '/BloodSugarData',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/bloodsugar/BloodSugarData.vue'],resovle),
                    meta: { title: '血糖仪详情' }
                },
                {
                    path: '/crutchList',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/crutch/crutchList.vue'],resovle),
                    meta: { title: '4G拐杖' }
                },
                // 智能药盒----------------------------------------------------------
                {
                    path: '/SmartPillboxList',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/smartpillbox/SmartPillboxList.vue'],resovle),
                    meta: { title: '智能药盒' }
                },
                 {
                    path: '/SmartPillboxData',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/smartpillbox/SmartPillboxData.vue'],resovle),
                    meta: { title: '智能药盒详情' }
                },
    
                {
                    path: '/SmartPillboxSetting',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/smartpillbox/SmartPillboxSetting.vue'],resovle),
                    meta: { title: '智能药盒设置' }
                },
                // -------------------------------------------------------------------------
                {
                    path: '/bracelet',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/bracelet/bracelet.vue'],resovle),
                    meta: { title: '体温定位手环' }
                },
                {
                    path: '/braceletDetail',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/bracelet/braceletDetail.vue'],resovle),
                    meta: { title: '手环详情' }
                },
                {
                    path: '/physicalList',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/examine/physicalList.vue'],resovle),
                    meta: { title: '体检一体机' }
                },
                {
                    path: '/Watchlist',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/watch/Watchlist.vue'],resovle),
                    meta: { title: '孝心环' }
                },
                {
                    path: '/Watchdetail',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/watch/Watchdetail.vue'],resovle),
                    meta: { title: '孝心环详情' }
                },
                {
                    path: '/Setarea',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/watch/Setarea.vue'],resovle),
                    meta: { title: '孝心环设置' }
                },
                {
                    path: '/Setarea',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/healthdevice/watch/Setarea.vue'],resovle),
                    meta: { title: '健康数据看板' }
                },
                {
                    path: '/Alarmlog',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/calldevice/Alarmlog.vue'],resovle),
                    meta: { title: '应急呼叫管理' }
                },
                {
                    path: '/CallCenter',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/calldevice/seats/CallCenter.vue'],resovle),
                    meta: { title: '呼叫中心' }
                },
                {
                    path: '/CallOrderManagement',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/calldevice/seats/CallOrderManagement.vue'],resovle),
                    meta: { title: '呼叫工单管理' }
                },
                {
                    path: '/CallInformationManagement',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/calldevice/seats/CallInformationManagement.vue'],resovle),
                    meta: { title: '呼叫信息管理' }
                },
                {
                    path: '/ComplainOrderManagement',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/calldevice/seats/ComplainOrderManagement.vue'],resovle),
                    meta: { title: '投诉工单管理' }
                },
                {
                    path: '/MagicBox',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/calldevice/mohe/MagicBox.vue'],resovle),
                    meta: { title: '智能魔盒' }
                },
                {
                    // RzjCardRecord
                    path: '/RzjCardRecord',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/site/RzjCardRecord.vue'],resovle),
                    meta: { title: '视频呼叫' }
                },
                {
                    path: '/moheLive',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/calldevice/mohe/moheLive.vue'],resovle),
                    meta: { title: '视频呼叫' }
                },
                {
                    path: '/CallGateWayDeviceList',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/calldevice/gateway/CallGateWayDeviceList.vue'],resovle),
                    meta: { title: '4G呼叫网关' }
                },
                {
                    path: '/CallPhoneDeviceList',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/calldevice/gateway/CallPhoneDeviceList.vue'],resovle),
                    meta: { title: '亲情通' }
                },
                {
                    path: '/AnniuDeviceList',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/calldevice/button/AnniuDeviceList.vue'],resovle),
                    meta: { title: '无线呼叫按钮' }
                },
                {
                    path: '/XiaoduSound',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/other/XiaoduSound.vue'],resovle),
                    meta: { title: '智能音箱' }
                },
                {
                    path: '/IntelligentManage',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/IntelligentManage.vue'],resovle),
                    meta: { title: '智能设备管理' }
                },
                {
                    path: '/oldActivity',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/activity/oldActivity.vue'],resovle),
                    meta: { title: '日常活动分析' }
                },
                {
                    path: '/doorManagement',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/door/doorManagement.vue'],resovle),
                    meta: { title: '门禁管理' }
                },
                {
                    path: '/Cardlist',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/door/Cardlist.vue'],resovle),
                    meta: { title: '门禁读卡器' }
                },
                {
                    path: '/Accesslist',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/door/Accesslist.vue'],resovle),
                    meta: { title: '门禁卡' }
                },
                {
                    path: '/DoorAllRecord',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/door/DoorAllRecord.vue'],resovle),
                    meta: { title: '出入记录' }
                },
                {
                    path: '/AccessControlCard',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/door/AccessControlCard.vue'],resovle),
                    meta: { title: '门禁控制卡' }
                },
                {
                    path: '/AccessAuthority',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/door/AccessAuthority.vue'],resovle),
                    meta: { title: '门禁卡权限' }
                },
                {
                    path: '/NursingWatch',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/other/NursingWatchList.vue'],resovle),
                    meta: { title: '护工手表' }
                },
                {
                    path: '/BedsideScreenList',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/other/BedsideScreenList.vue'],resovle),
                    meta: { title: '床头屏' }
                },
                {
                    path: '/PatrolManagement',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/patrol/PatrolManagement.vue'],resovle),
                    meta: { title: '巡更管理' }
                },
                {
                    path: '/PatrolView',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/patrol/PatrolView.vue'],resovle),
                    meta: { title: '巡更记录查看' }
                },
                {
                    path: '/PatrollingRod',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/patrol/PatrollingRod.vue'],resovle),
                    meta: { title: '巡更棒管理' }
                },
                {
                    path: '/PatrolPoints',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/patrol/PatrolPoints.vue'],resovle),
                    meta: { title: '巡更点管理' }
                },
                {
                    path: '/PatrolReminder',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/patrol/PatrolReminder.vue'],resovle),
                    meta: { title: '巡更提醒' }
                },
                {
                    path: '/PatrollingRecord',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/patrol/PatrollingRecord.vue'],resovle),
                    meta: { title: '巡更记录' }
                },
                {
                    path: '/PatrollingSeting',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/patrol/PatrollingSeting.vue'],resovle),
                    meta: { title: '巡更设置' }
                },
                {
                    path: '/TourTimeSetting',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/patrol/TourTimeSetting.vue'],resovle),
                    meta: { title: '巡更时间设置' }
                },
                {
                    path: '/YsCamera',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/camera/YsCamera.vue'],resovle),
                    meta: { title: '萤石云摄像头' }
                },
                {
                    path: '/DxCamera',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/camera/DxCamera.vue'],resovle),
                    meta: { title: '电信摄像头' }
                },

                {
                    path: '/camera',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/camera/camera.vue'],resovle),
                    meta: { title: '萤石云管理' }
                },
                {
                    path: '/cameraAisse',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/camera/cameraAisse.vue'],resovle),
                    meta: { title: '监控通道管理' }
                },
                {
                    path: '/cameraAppInfo',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/camera/cameraAppInfo.vue'],resovle),
                    meta: { title: '摄像头设置' }
                },
                {
                    path: '/fallManage',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/fall/fallManage.vue'],resovle),
                    meta: { title: '跌倒设备管理' }
                },
                {
                    path: '/AotongCamera',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/fall/AotongCamera.vue'],resovle),
                    meta: { title: '奥瞳摄像头' }
                },
                {
                    path: '/AotongLive',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/fall/AotongLive.vue'],resovle),
                    meta: { title: '奥瞳实时视频' }
                },
                {
                    path: '/FallRadarList',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/fall/FallRadarList.vue'],resovle),
                    meta: { title: '跌倒雷达' }
                },
                {
                    path: '/FallRadarDetail',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/fall/FallRadarDetail.vue'],resovle),
                    meta: { title: '跌倒雷达详情' }
                },
                {
                    path: '/attendanceList',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/attendance/attendanceList.vue'],resovle),
                    meta: { title: '考勤打卡机' }
                },
                {
                    path: '/safetyManagement',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/safety/safetyManagement.vue'],resovle),
                    meta: { title: '安防设备管理' }
                },
                {
                    path: '/LnfraredLnductor',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/safety/LnfraredLnductor.vue'],resovle),
                    meta: { title: '红外感应器' }
                },
                {
                    path: '/UrgencyBeeper',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/safety/UrgencyBeeper.vue'],resovle),
                    meta: { title: '紧急呼叫器' }
                },
                {
                    path: '/SmogAlertor',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/safety/SmogAlertor.vue'],resovle),
                    meta: { title: '烟雾报警器' }
                },
                {
                    path: '/MagneticLnductor',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/safety/MagneticLnductor.vue'],resovle),
                    meta: { title: '门窗感应器' }
                },
                {
                    path: '/FuelAlertor',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/safety/FuelAlertor.vue'],resovle),
                    meta: { title: '燃气报警器' }
                },
                {
                    path: '/overflowAlertor',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/safety/overflowAlertor.vue'],resovle),
                    meta: { title: '水溢传感器' }
                },
                {
                    path: '/wifiDeviceList',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/wifi/wifiDeviceList.vue'],resovle),
                    meta: { title: '无线网卡管理' }
                },
                {
                    path: '/eMeterList',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/meter/eMeterList.vue'],resovle),
                    meta: { title: '智能电表' }
                },
                {
                    path: '/wMeterList',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/meter/wMeterList.vue'],resovle),
                    meta: { title: '智能水表' }
                },
                {
                    path: '/deviceManager',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/deviceManager.vue'],resovle),
                    meta: { title: '设备管理' }
                },
                {
                    path: '/DeviceLogTable',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/activity/deviceLog.vue'],resovle),
                    meta: { title: '设备日志' }
                },
                {
                    path: '/deviceOpen',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/deviceOpen.vue'],resovle),
                    meta: { title: '设备开通' }
                },
                {
                    path: '/deviceSetting',
                    component: resovle => require([/* webpackChunkName: "main" */'../views/intellectdevice/deviceSetting.vue'],resovle),
                    meta: { title: '设备设置' }
                },
                {
                    path: '/SetManagement',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/setting/SetManagement.vue'],resovle),
                    meta: { title: '系统设置' }
                },
                {
                    path: '/GroupInfo',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/setting/GroupInfo.vue'],resovle),
                    meta: { title: '机构介绍' }
                },
                {
                    path: '/InformationMassagePush',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/setting/InformationMassagePush.vue'],resovle),
                    meta: { title: '信息发布' }
                },
                {
                    path: '/ActiveList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/setting/ActiveList.vue'],resovle),
                    meta: { title: '活动发布' }
                },
                {
                    path: '/ActivePush',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/setting/ActivePush.vue'],resovle),
                    meta: { title: '活动发布' }
                },
                {
                    path: '/Dictionary',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/setting/Dictionary.vue'],resovle),
                    meta: { title: '数据字典' }
                },
                {
                    path: '/CourseManage',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/setting/CourseManage.vue'],resovle),
                    meta: { title: '课程活动管理' }
                },
                {
                    path: '/EvaluationList',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/setting/EvaluationList.vue'],resovle),
                    meta: { title: '评估项目管理' }
                },
                {
                    path: '/GroupThresholdSetting',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/setting/GroupThresholdSetting.vue'],resovle),
                    meta: { title: '机构阈值管理' }
                },
                {
                    path: '/entertainmentManagement',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/setting/game/entertainmentManagement.vue'],resovle),
                    meta: { title: '娱乐管理' }
                },
                {
                    path: '/musicManagement',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/setting/game/musicManagement.vue'],resovle),
                    meta: { title: '音乐管理' }
                },
                {
                    path: '/videoManagement',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/setting/game/videoManagement.vue'],resovle),
                    meta: { title: '视频管理' }
                },
                {
                    path: '/voiceManagement',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/setting/game/voiceManagement.vue'],resovle),
                    meta: { title: '语音管理' }
                },
                {
                    path: '/VersionInfo',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/setting/VersionInfo.vue'],resovle),
                    meta: { title: '版本管理' }
                },
                /**志愿者服务 */
                {
                    path: '/VolunteerManage',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/volunteer/volunteerManage/VolunteerManage.vue'],resovle),
                    meta: { title: '志愿者管理' }
                },
                {
                    path: '/Volunteerlist',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/volunteer/volunteer/Volunteerlist.vue'],resovle),
                    meta: { title: '志愿者列表' }
                },
                {
                    path: '/Volunteerdetail',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/volunteer/volunteer/Volunteerdetail.vue'],resovle),
                    meta: { title: '志愿者详情' }
                },
                {
                    path: '/Volunteerservicelist',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/volunteer/volunteerservice/Volunteerservicelist.vue'],resovle),
                    meta: { title: '志愿者服务列表' }
                },
                {
                    path: '/VolunteerserviceCompile',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/volunteer/volunteerservice/VolunteerserviceCompile.vue'],resovle),
                    meta: { title: '编辑志愿者服务' }
                },
                {
                    path: '/VolunteerserviceDetail',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/volunteer/volunteerservice/VolunteerserviceDetail.vue'],resovle),
                    meta: { title: '服务详情' }
                },
                {
                    path: '/InspectOrderlist',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/volunteer/inspectorder/InspectOrderlist.vue'],resovle),
                    meta: { title: '服务订单' }
                },
                {
                    path: '/OrderRecord',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/volunteer/inspectorder/OrderRecord.vue'],resovle),
                    meta: { title: '订单详情' }
                },
                {
                    path: '/Volunteergiftslist',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/volunteer/volunteergifts/Volunteergiftslist.vue'],resovle),
                    meta: { title: '志愿者礼品列表' }
                },
                {
                    path: '/VolunteergiftsCompile',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/volunteer/volunteergifts/VolunteergiftsCompile.vue'],resovle),
                    meta: { title: '编辑志愿者礼品' }
                },
                {
                    path: '/VolunteergiftsDetail',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/volunteer/volunteergifts/VolunteergiftsDetail.vue'],resovle),
                    meta: { title: '礼品详情' }
                },
                {
                    path: '/VolunteergiftsRecord',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/volunteer/volunteergifts/VolunteergiftsRecord.vue'],resovle),
                    meta: { title: '礼品兑换' }
                },
                {
                    path: '/VolunteergiftsRecordDetail',
                    component: resovle => require([/* webpackChunkName: "main" */ '../views/volunteer/volunteergifts/VolunteergiftsRecordDetail.vue'],resovle),
                    meta: { title: '礼品兑换详情' }
                },
                //志愿者end
                {
                  path: "/ServiceManage",
                  component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/ServiceManage.vue'],resovle),
                  meta: { title: '居家服务管理' }
                },
                {
                  path: "/ServiceCategory",
                  component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/ServiceCategory.vue'],resovle),
                  meta: { title: '服务类别管理' }
                },
                {
                  path: "/ServicePersonnel",
                  component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/ServicePersonnel.vue'],resovle),
                  meta: { title: '服务人员管理' }
                },
                {
                    path: "/ServiceSpecial",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/ServiceSpecial.vue'],resovle),
                    meta: { title: '专家管理' }
                },
                {
                    path: "/ServiceWorkOrder",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/ServiceWorkOrder.vue'],resovle),
                    meta: { title: '服务工单管理' }
                },
                {
                    path: "/ServiceErrorWorkOrder",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/ServiceErrorWorkOrder.vue'],resovle),
                    meta: { title: '异常工单管理' }
                },
                {
                    path: "/OldArrearageList",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/OldArrearageList.vue'],resovle),
                    meta: { title: '老人余额管理' }
                },
                {
                    path: "/ServicePeopleAdd",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/ServicePeopleAdd.vue'],resovle),
                    meta: { title: '服务人员新增' }
                },
                {
                    path: "/UserNotServiceMonth",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/UserNotServiceMonth.vue'],resovle),
                    meta: { title: '当月未服务老人' }
                },
                {
                    path: "/NotServiceOldReason",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/NotServiceOldReason.vue'],resovle),
                    meta: { title: '未服务原因申请' }
                },
                {
                    path: "/UserAccountDetail",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/UserAccountDetail.vue'],resovle),
                    meta: { title: '用户账户余额' }
                },
                {
                    path: "/OrderDetail",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/OrderDetail.vue'],resovle),
                    meta: { title: '服务工单详情' }
                },
                {
                    path: "/ServiceGroup",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/ServiceGroup.vue'],resovle),
                    meta: { title: '服务组管理' }
                },
                {
                    path: "/ServiceReport",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/ServiceReport.vue'],resovle),
                    meta: { title: '报表统计' }
                },
                {
                    path: "/serviceComment",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/serviceComment.vue'],resovle),
                    meta: { title: '商家评论' }
                },
                {
                    path: "/ServiceCategoryNew",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/ServiceCategoryNew.vue'],resovle),
                    meta: { title: '服务类别管理' }
                },
                {
                    path: "/Telemedicine",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/Telemedicine.vue'],resovle),
                    meta: { title: '远程监护管理' }
                },
                {
                    path: "/TelemedicineWorkOrder",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/TelemedicineWorkOrder.vue'],resovle),
                    meta: { title: '远程监护订单' }
                },
                {
                    path: "/BusinessProgramManage",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/BusinessProgramManage.vue'],resovle),
                    meta: { title: '商家项目管理' }
                },
                {
                    path: "/program",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/program.vue'],resovle),
                    meta: { title: '项目管理' }
                },
                {
                    path: "/MerchantManagement",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/MerchantManagement.vue'],resovle),
                    meta: { title: '商家管理' }
                },
                {
                    path: "/BusinessWorkOrder",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/BusinessWorkOrder.vue'],resovle),
                    meta: { title: '商家工单管理' }
                },
                {
                    path: "/comment",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/comment.vue'],resovle),
                    meta: { title: '服务评价' }
                },
                {
                    path: "/BusinessReport",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/BusinessReport.vue'],resovle),
                    meta: { title: '统计报表' }
                },
                {
                    path: "/BusinessHoursSetting",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/BusinessHoursSetting.vue'],resovle),
                    meta: { title: '营业时间设置' }
                },
                {
                    path: "/programEdit",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/programEdit.vue'],resovle),
                    meta: { title: '项目管理' }
                },
                {
                    path: "/ServiceYuyue",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/ServiceYuyue.vue'],resovle),
                    meta: { title: '服务预约管理' }
                },
                {
                    path: "/packageList",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/packageList.vue'],resovle),
                    meta: { title: ' 服务套餐管理' }
                },
                {
                    path: "/packageRecord",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/packageRecord.vue'],resovle),
                    meta: { title: ' 套餐购买记录' }
                },
                {
                    path: "/packageRemindTime",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/homecare/packageRemindTime.vue'],resovle),
                    meta: { title: '套餐剩余次数' }
                },
                {
                    path: "/canteenRecord",
                    component: resovle => require([/* webpackChunkName: "main" */'../views/canteen/canteenRecord.vue'],resovle),
                    meta: { title: '食堂就餐记录' }
                },
                //服务结束
                {
                    path: '/404',
                    component: resovle => require([/* webpackChunkName: "main" */'../components/page/404.vue'],resovle),
                    meta: { title: '404' }
                },
            ]
        },
        {
            path: '/login',
            component: resovle => require([/* webpackChunkName: "login" */'../views/login/Login.vue'],resovle),
            meta: { title: '登录' }
        },
        {
            path:'/bigView',
            component: resovle => require([/* webpackChunkName: "main" */'../views/bigview/bigView.vue'],resovle),
            meta: { title: '大数据平台' }
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
});